import type { LocatorJson } from "@msb/reader-bridge";

/**
 * Historique de navigation, comme NavigationHistory.kt dans l'app : un saut empile la position
 * quittée et vide l'avant ; revenir en arrière empile la position courante à l'avant.
 */
export interface NavigationHistory {
  backward: LocatorJson[];
  forward: LocatorJson[];
}

export const emptyHistory: NavigationHistory = { backward: [], forward: [] };

export function recordJump(history: NavigationHistory, current: LocatorJson): NavigationHistory {
  return { backward: [...history.backward, current], forward: [] };
}

export function stepBackward(history: NavigationHistory, current: LocatorJson): { history: NavigationHistory; target: LocatorJson } | undefined {
  const target = history.backward.at(-1);
  if (!target) return undefined;
  return { target, history: { backward: history.backward.slice(0, -1), forward: [current, ...history.forward] } };
}

export function stepForward(history: NavigationHistory, current: LocatorJson): { history: NavigationHistory; target: LocatorJson } | undefined {
  const target = history.forward[0];
  if (!target) return undefined;
  return { target, history: { backward: [...history.backward, current], forward: history.forward.slice(1) } };
}

export const positionOf = (locator: LocatorJson | undefined) =>
  typeof locator?.locations?.position === "number" ? locator.locations.position : undefined;
